import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Modal } from "angular2-modal/plugins/bootstrap";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { GlobalEventMangerService } from "../global-event-manger.service";

import { EchexpaymentService } from "../echexpayment.service";
import { LocalstorageService } from "../localstorage.service";
import { UserService } from "../user.service";
import { ScriptService } from "../script.service";
declare var Plaid: any;
@Component({
    selector: "echexpayment-wanttoprintsendcheck",
    templateUrl: "./wanttoprintsendcheck.component.html",
    styleUrls: ["./sendcheck.component.css"]
})
export class WanttoprintsendcheckComponent implements OnInit {
    public printCheck: any = {};
    public token: string;
    public user_id: string;
    busy: Subscription;
    public merchantImg_url: string;
    public showDirectDepositBtn: boolean = false;
    public direcDepositSettings: string;
    public jsonReponseTxt: string;
    // Plaid variable
    linkHandler: any;
    public plaid_link_token: string;
    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        private toastr: ToastrService,
        protected userService: UserService,
        protected echexpaymentService: EchexpaymentService,
        protected localStorageService: LocalstorageService,
        vcRef: ViewContainerRef,
        public modal: Modal,
        private globalEventMangerService: GlobalEventMangerService,
        private scriptService: ScriptService,
    ) {
        this.router = router;
        var currentUser = this.localStorageService.getData("currentUserToken");
        //this.token =  currentUser.token;
        let userDetails = <any>{};
        let Business_image = <any>{};
        userDetails = this.localStorageService.getData("currentUser");
        Business_image = this.localStorageService.getData("Mer_Profile_image");
        this.merchantImg_url = Business_image
            ? Business_image.business_image_url
            : userDetails && userDetails.business_image_url;
    }

    ngOnInit() {
        this.wantToPrintCheck();
    }

    // Want to print
    wantToPrintCheck() {
        let params: any = this.route.snapshot.params;
        let data = {
            //token:this.token,
            id: params.id
        };
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .wantToPrintCheckApi(data)
            .subscribe(
                response => {
                    responseData = response;
                    this.printCheck = responseData.data;
                    if (responseData.data.is_printed == 1) {
                        this.router.navigate([
                            "/printed/send/cheque/",
                            params.id
                        ]);
                    } else {
                        let checkDirectDepositData = <any>{};
                        this.echexpaymentService
                            .checkDirectDepositData(data)
                            .subscribe(
                                response => {
                                    checkDirectDepositData = response;
                                    this.showDirectDepositBtn = checkDirectDepositData.data.direct_deposit;
                                    this.direcDepositSettings = checkDirectDepositData.data.automatic_type;
                                },
                                error => {
                                    checkDirectDepositData = error;
                                    this.toastr.error(
                                        checkDirectDepositData.error.message,
                                        "Failed!"
                                    );
                                }
                            );
                    }
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, "Failed!");
                }
            );
    }

    // Print send cheque
    printSendCheque() {
        this.modal
            .confirm()
            .size("sm")
            .title("CasherPay")
            .body(`Are you sure  want to print the Check.`)
            .okBtn("Okay")
            .cancelBtn("Cancel")
            .okBtnClass("btn btn-success")
            .cancelBtnClass("btn btn-warning")
            .open()
            .then(resultPromise => {
                resultPromise.result.then(
                    result => {
                        var chequeIds = new Array();
                        let params: any = this.route.snapshot.params;
                        chequeIds[0] = params.id;
                        let data = {
                            cheque_id: chequeIds,
                            action: "sendChequePrint"
                        };
                        var googleWindow = window.open();
                        let responseData = <any>{};
                        this.busy = this.echexpaymentService
                            .printSendChequeApi(data)
                            .subscribe(
                                res => {
                                    responseData = res;
                                    var file = new Blob([responseData], {
                                        type: "application/pdf"
                                    });
                                    var fileURL = URL.createObjectURL(file);
                                    googleWindow.location.replace(fileURL);
                                    this.updatePrintCheckStatus(params.id);
                                },
                                error => {
                                    responseData = error;
                                    this.toastr.error(
                                        responseData.error.message,
                                        "Failed!"
                                    );
                                }
                            );
                    },
                    () => {}
                );
            });
    }
    // Update print cheque status
    updatePrintCheckStatus(id) {
        var data = {
            _id: id,
            status: "1"
        };
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .updatePrintCheckStatusApi(data)
            .subscribe(
                res => {
                    console.log("updated:printed");
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, "Failed!");
                }
            );
    }

    // loadPopUp
    loadPopUp() {
        let data = { user_token: this.token };
        let responseData = <any>{};
        this.busy = this.userService.ConectBankV2(data).subscribe(response => {
            responseData = response;
            this.plaid_link_token = responseData.data.link_token;
            this.linkHandler = Plaid.create({
                token: this.plaid_link_token,
                onSuccess: function(public_token, metadata) {
                    (document.getElementById(
                        "publictoken"
                    ) as HTMLInputElement).value = public_token;
                    var l = document.getElementById("submitToGetInfo");
                    l.click();
                },
                onExit: function(err, metadata) {
                    // The user exited the Link flow.
                    if (err != null) {
                    }
                }
            });
        });
    }

    // get info from Plaid
    getInfoFromPlaid() {
        var public_token = (document.getElementById(
            "publictoken"
        ) as HTMLInputElement).value;
        var data = {
            PlaidInfo: true,
            token: public_token,
            amount: 1
        };
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .getInfoFromPlaidApi(data)
            .subscribe(
                response => {
                    responseData = response;
                    this.saveDepositInformation(responseData.data);
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, 'Failed!');
                }
            );
    }

    // get info from Plaid
    saveDepositInformation(response_data) {
        let params: any = this.route.snapshot.params;
        var data = response_data;
        data.cheque_id = [params.id];
        data.direct_deposit = this.showDirectDepositBtn;
        data.automatic_type = this.direcDepositSettings;
        data.transaction_type = 1;
        let responseData = <any>{};
        this.busy = this.echexpaymentService
            .saveDepositCustomerInfo(data)
            .subscribe(
                response => {
                    responseData = response;
                    this.toastr.success('Deposited successfully', 'Success!');
                    this.jsonReponseTxt = JSON.stringify(responseData.data);
                },
                error => {
                    responseData = error;
                    this.toastr.error(responseData.error.message, 'Failed!');
                }
            );
    }

    // Open Plaid popup
    ConnectBank() {
        this.linkHandler.open();
    }

    ngAfterViewInit() {
        this.scriptService
            .load("Plaid")
            .then(data => {
                this.loadPopUp();
            })
            .catch(error => console.log(error));
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/sendcheck/wanttoprintsendcheck.component.ts